import { icon } from "./icons";
import type { FaqContent, FaqGroupId } from "../i18n/types";

/** Category ids — structural; the category switch matches on them. */
const GROUP_IDS: FaqGroupId[] = ["getting-started", "models", "security", "billing"];

export function renderFAQ(t: FaqContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section faq";
  root.id = "faq";
  root.innerHTML = `
    <div class="page">
      <div class="section-head section-head--center" data-reveal>
        <h2 class="section__title">${t.title}</h2>
      </div>
      <div class="faq__grid" data-reveal style="--reveal-delay:80ms">
        <nav class="faq__cats" aria-label="${t.categoriesAriaLabel}">
          ${t.groups.map((g, i) => `
            <button class="faq__cat ${i === 0 ? "is-active" : ""}" data-cat="${GROUP_IDS[i]}">${g.label}</button>
          `).join("")}
        </nav>
        <div class="faq__items">
          ${t.groups.map((g, i) => `
            <div class="faq__group ${i === 0 ? "is-active" : ""}" data-cat="${GROUP_IDS[i]}">
              ${g.items.map((it) => `
                <div class="faq__item">
                  <button class="faq__q" type="button">
                    <span>${it.q}</span>
                    ${icon.chevron({ size: 16, class: "chev" })}
                  </button>
                  <div class="faq__a"><p>${it.a}</p></div>
                </div>
              `).join("")}
            </div>
          `).join("")}
        </div>
      </div>
    </div>
  `;

  // Category switching.
  const cats = Array.from(root.querySelectorAll<HTMLButtonElement>(".faq__cat"));
  const groups = Array.from(root.querySelectorAll<HTMLElement>(".faq__group"));
  for (const cat of cats) {
    cat.addEventListener("click", () => {
      const id = cat.dataset.cat;
      for (const c of cats) c.classList.toggle("is-active", c === cat);
      for (const g of groups) g.classList.toggle("is-active", g.dataset.cat === id);
      // Close any open items when switching categories so the column resets.
      for (const item of root.querySelectorAll<HTMLElement>(".faq__item.is-open")) {
        item.classList.remove("is-open");
      }
    });
  }

  // Accordion behavior: clicking a question toggles its parent .faq__item.
  const questions = Array.from(root.querySelectorAll<HTMLButtonElement>(".faq__q"));
  for (const q of questions) {
    q.addEventListener("click", () => {
      const item = q.parentElement;
      if (!item) return;
      const wasOpen = item.classList.contains("is-open");
      // Close siblings within the same group for a single-open accordion.
      const group = item.parentElement;
      if (!group) return;
      for (const sib of Array.from(group.querySelectorAll<HTMLElement>(".faq__item.is-open"))) {
        sib.classList.remove("is-open");
      }
      if (!wasOpen) item.classList.add("is-open");
    });
  }

  return root;
}
